import actions from './ProgramariActions'
import mutations from './ProgramariMutations'

export default {
  namespaced: true,
  state: {
    programari: [],
    dprogramare: [],
    aprogramare: [],
    eprogramare: [],
    programare: []
  },
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/programari/index.js